import React from "react";
import StatusBadge from "@/components/StatusBadge";
import { Status } from "@/types";

interface TimelineEntry {
  status: string;
  date: string;
  updatedBy: string;
  signature?: string;
  receiverName?: string;
}

interface StatusTimelineProps {
  history: TimelineEntry[];
}

const formatDateTime = (dateString: string) => {
  try {
    const date = new Date(dateString);
    return date.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return dateString;
  }
};

const StatusTimeline: React.FC<StatusTimelineProps> = ({ history }) => {
  if (!history || history.length === 0) return null;
  // Sort oldest to newest
  const sorted = [...history].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  return (
    <div className="mt-6">
      <div className="font-semibold mb-2 text-gray-800 dark:text-gray-200">Status Timeline</div>
      <ol className="relative border-l border-gray-300 dark:border-gray-700">
        {sorted.map((entry, idx) => (
          <li key={idx} className="mb-6 ml-4">
            <div className="flex items-center gap-2 mb-1">
              {entry.status === 'Created' ? (
                <span className="text-lg">📦</span>
              ) : entry.status === 'Edited' ? (
                <span className="text-lg">✏️</span>
              ) : (
                <StatusBadge status={entry.status as Status} />
              )}
              <span className="text-sm text-gray-700 dark:text-gray-300 font-medium">
                {entry.status === 'Created' ? (
                  <>Package created by <b>{entry.updatedBy}</b> on {formatDateTime(entry.date)}</>
                ) : entry.status === 'Edited' ? (
                  <>Package details edited by <b>{entry.updatedBy}</b> on {formatDateTime(entry.date)}</>
                ) : (
                  <>Status changed to <span className="capitalize">{entry.status}</span> by <b>{entry.updatedBy}</b> on {formatDateTime(entry.date)}</>
                )}
              </span>
            </div>
            {entry.signature && (
              <div className="text-xs text-gray-500">Signature: <span className="font-mono">{entry.signature}</span></div>
            )}
            {entry.receiverName && (
              <div className="text-xs text-gray-500">Receiver: <span className="font-mono">{entry.receiverName}</span></div>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default StatusTimeline; 